module.exports = __webpack_public_path__ + "eb1d959bd3123eef7fb55c75100a1bef.png";